export class HttpRes {
   /**
    * HttpRes constructor
    * @param {Boolean} success 
    * @param {*} data 
    * @param {String} error 
    */
   constructor (success, data = null, error = null){
      this.success = success
      this.data = data
      this.error = error
   }
}